import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ConfirmSubscription() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.get("/public/newsletter/confirm", { params: { token } })
      .then(() => {
        setState("ok");
        // strip the raw token from the URL immediately (no history/referrer leak)
        window.history.replaceState({}, "", "/newsletter/confirm");
      })
      .catch(() => setState("error"));
  }, [token]);

  const resend = async (e) => {
    e.preventDefault();
    try {
      await api.post("/public/newsletter/resend-confirmation", { email });
      toast.success("If a pending subscription exists, a new confirmation email has been sent.");
    } catch { toast.error("Could not process request."); }
  };

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 py-20 text-center" data-testid="confirm-page">
      <title>Confirm Subscription | Be-Apuo</title>
      <meta name="referrer" content="no-referrer" />
      {state === "loading" && <p className="text-ink/55">Confirming…</p>}
      {state === "ok" && (
        <div data-testid="confirm-success">
          <div className="label-caps text-clay">Newsletter</div>
          <h1 className="mt-2 font-editorial font-black text-3xl text-ink">You're confirmed</h1>
          <p className="mt-3 text-ink/60">Your subscription is active. Welcome to Be-Apuo Media Intelligence.</p>
          <Link to="/" className="inline-block mt-6 bg-heritage text-paper px-5 py-2.5 text-sm font-semibold hover:bg-heritage/90 transition-colors">Back to home</Link>
        </div>
      )}
      {state === "error" && (
        <div data-testid="confirm-error">
          <h1 className="font-editorial font-black text-2xl text-ink">Link expired or invalid</h1>
          <p className="mt-3 text-sm text-ink/60">Confirmation links expire after 24 hours and can be used once. Request a new one below.</p>
          <form onSubmit={resend} className="mt-6 flex gap-2 justify-center">
            <label htmlFor="resend-email-input" className="sr-only">Email address</label>
            <input id="resend-email-input" data-testid="resend-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
              className="flex-1 max-w-xs border border-ink/20 bg-white px-3 py-2 text-sm text-ink focus:outline-none focus:border-heritage" />
            <button data-testid="resend-btn" type="submit" className="bg-heritage text-paper px-4 py-2 text-sm font-semibold hover:bg-heritage/90 transition-colors">Resend</button>
          </form>
        </div>
      )}
    </div>
  );
}
